import { basePath } from "../constants/enum"
const checkPath = () => {
  //TODO: Figure out how to check the correct path
  
  // const path = new URL(window.location.href).pathname
  // return path === basePath
  return true
}

export {checkPath}